import { axios } from '@/utils/request'
import ipConfig from '@../../../config/ip.config'

// 查询外贸业务数量
export const getDataStatistics = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetDataStatistics`,
  method: 'get',
  params: query
})

// 查询外贸业务统计接口
export const getBusinessStatisticsTotal = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetBusinessStatisticsTotal`,
  method: 'get',
  params: query
})

// 查询外贸箱量/体积统计
export const getBusinessStatisticsCBMTotal = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetBusinessStatisticsCBMTotal`,
  method: 'get',
  params: query
})

// 数据外贸明细详情信息
export const getTEImportPageList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTEImportPageList`,
  method: 'get',
  params: query
})

// 获取外贸附件
export const getFileListByBookingNo = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetAllFileListByBookingNo`,
  method: 'get',
  params: query
})

// 下载外贸附件
export const getFileBlob = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetFileBlob`,
  method: 'post',
  params: query
})

// 订阅详情
export const getMilestoneList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetMilestoneList`,
  method: 'get',
  params: query
})

// 获取订阅实体信息
export const getMailSubscription = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetMailSubscription`,
  method: 'get',
  params: query
})

// 删除订阅详情
export const delMilestone = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/DelMilestone`,
  method: 'post',
  params: query
})

// 获取港口名称
export const getPortsList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetPortsList`,
  method: 'get',
  params: query
})

// 获取品名
export const getGoodsList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetGoodsList`,
  method: 'get',
  params: query
})

// 获取订阅节点COde
export const getMilestoneCodeList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetMilestoneCodeList`,
  method: 'get',
  params: query
})

// 提交订阅
export const saveMilestoneMan = (data) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/SaveMilestoneMan`,
  method: 'post',
  data
})

// 数据内贸明细详情信息
export const getTDImportPageList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTDImportPageList`,
  method: 'get',
  params: query
})

// 查询内贸业务数量
export const getTDDataStatistics = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTDDataStatistics`,
  method: 'get',
  params: query
})

// 查询内贸业务统计接口
export const getTDBusinessStatisticsTotal = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTDBusinessStatisticsTotal`,
  method: 'get',
  params: query
})

// 查询内贸箱量/体积统计
export const getTDBusinessStatisticsCBMTotal = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTDBusinessStatisticsCBMTotal`,
  method: 'get',
  params: query
})
// 获取内贸附件
export const getTDFileListByBookingNo = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTDAllFileListByBookingNo`,
  method: 'get',
  params: query
})

// 查询堆场业务数量
export const getTYDataStatistics = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTYDataStatistics`,
  method: 'get',
  params: query
})

// 查询堆场业务统计接口
export const getTYBusinessStatisticsTotal = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTYBusinessStatisticsTotal`,
  method: 'get',
  params: query
})

// 数据堆场明细详情信息
export const getTYImportPageList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetTYImportPageList`,
  method: 'get',
  params: query
})

// 获取堆场附件
export const getFileListByYardScheduleID = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetFileListByYardScheduleID`,
  method: 'get',
  params: query
})

// 获取客户罐群管理信息
export const getBorrowNewPageList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetBorrowNewPageList`,
  method: 'get',
  params: query
})
// 获取客户跟踪管理信息
export const getKeyAccountPageList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetKeyAccountPageList`,
  method: 'get',
  params: query
})
// 获取客户回程跟踪信息
export const getReturnKeyAccountPageList = (query) => axios({
  url: ipConfig.api_tankedi + `/api/TankInternational/GetReturnKeyAccountPageList`,
  method: 'get',
  params: query
})


